import React from 'react';
// Mock data for properties
export const allProperties = [{
  id: 1,
  title: 'Charming Beachside Bed & Breakfast',
  description: 'Experience authentic coastal hospitality in this family-run B&B. Wake up to homemade gourmet breakfasts featuring local ingredients, then stroll to the nearby beach. Each room is uniquely decorated with vintage coastal decor and luxury linens for a truly personal stay.',
  location: 'Malibu, California',
  images: ['https://images.unsplash.com/photo-1566073771259-6a8506099945?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80', 'https://images.unsplash.com/photo-1564501049412-61c2a3083791?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1332&q=80', 'https://images.unsplash.com/photo-1578683010236-d716f9a3f461?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80', 'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80', 'https://images.unsplash.com/photo-1604709177225-055f99402ea3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80'],
  pricePerNight: 250,
  rating: 4.9,
  reviewCount: 48,
  propertyType: 'bnb',
  bedrooms: 5,
  beds: 7,
  bathrooms: 4,
  maxGuests: 12,
  amenities: ['Wi-Fi', 'Gourmet breakfast included', 'Ocean view terrace', 'Free parking', 'Air conditioning', 'Private bathroom', 'Luxury linens', 'Daily housekeeping', 'Tea & coffee service', 'Beach access'],
  host: {
    id: 1,
    name: 'Sarah',
    avatar: 'https://randomuser.me/api/portraits/women/44.jpg'
  },
  reviews: [{
    user: {
      name: 'Michael',
      avatar: 'https://randomuser.me/api/portraits/men/32.jpg'
    },
    date: 'August 2023',
    comment: "Sarah's B&B is a hidden gem! The homemade breakfasts were incredible and the rooms are so charming. Perfect location near the beach."
  }, {
    user: {
      name: 'Jessica',
      avatar: 'https://randomuser.me/api/portraits/women/17.jpg'
    },
    date: 'July 2023',
    comment: "This place exceeded all our expectations. The personal touches and attention to detail made us feel so welcome. We'll definitely return!"
  }, {
    user: {
      name: 'Robert',
      avatar: 'https://randomuser.me/api/portraits/men/91.jpg'
    },
    date: 'June 2023',
    comment: 'Sarah is an exceptional host. The B&B is beautifully maintained, and her local recommendations made our trip truly special.'
  }]
}, {
  id: 2,
  title: 'Historic Downtown Bed & Breakfast',
  description: 'Stay in this beautifully preserved Victorian B&B in the heart of the city. Each morning begins with a gourmet multi-course breakfast served in our elegant dining room. Our innkeepers offer personalized concierge service to help you discover local hidden gems.',
  location: 'New York City, New York',
  images: ['https://images.unsplash.com/photo-1596394516093-501ba68a0ba6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80', 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80', 'https://images.unsplash.com/photo-1484154218962-a197022b5858?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1174&q=80', 'https://images.unsplash.com/photo-1493809842364-78817add7ffb?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80', 'https://images.unsplash.com/photo-1484101403633-562f891dc89a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1174&q=80'],
  pricePerNight: 280,
  rating: 4.7,
  reviewCount: 124,
  propertyType: 'bnb',
  bedrooms: 6,
  beds: 7,
  bathrooms: 6,
  maxGuests: 12,
  amenities: ['Wi-Fi', 'Gourmet breakfast included', 'Evening wine reception', 'Afternoon tea service', 'Air conditioning', 'Private bathroom', 'Luxury linens', 'Antique furnishings', 'Library', 'Garden terrace'],
  host: {
    id: 2,
    name: 'David',
    avatar: 'https://randomuser.me/api/portraits/men/67.jpg'
  },
  reviews: [{
    user: {
      name: 'Emily',
      avatar: 'https://randomuser.me/api/portraits/women/33.jpg'
    },
    date: 'September 2023',
    comment: 'This historic B&B is absolutely charming! The breakfast was restaurant quality and David gave us wonderful recommendations for local spots.'
  }, {
    user: {
      name: 'James',
      avatar: 'https://randomuser.me/api/portraits/men/55.jpg'
    },
    date: 'August 2023',
    comment: 'Staying in this beautifully preserved Victorian home was like stepping back in time, but with all modern comforts. The attention to detail is remarkable.'
  }, {
    user: {
      name: 'Sophia',
      avatar: 'https://randomuser.me/api/portraits/women/75.jpg'
    },
    date: 'July 2023',
    comment: 'The evening wine reception was a lovely touch! We met interesting guests and David shared fascinating stories about the history of the house.'
  }]
}, {
  id: 3,
  title: 'Mountain View Farmstay with Animal Experiences',
  description: 'Connect with nature at our working farm nestled in the mountains. Help collect fresh eggs for breakfast, milk the cows, or simply relax and enjoy the peaceful surroundings. Our rustic yet comfortable accommodations offer an authentic farm experience with modern amenities.',
  location: 'Aspen, Colorado',
  images: ['https://images.unsplash.com/photo-1500076656116-558758c991c1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1171&q=80', 'https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80', 'https://images.unsplash.com/photo-1542718610-a1d656d1884c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80', 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=958&q=80', 'https://images.unsplash.com/photo-1482192596544-9eb780fc7f66?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80'],
  pricePerNight: 195,
  rating: 4.8,
  reviewCount: 87,
  propertyType: 'farmstay',
  bedrooms: 2,
  beds: 3,
  bathrooms: 1,
  maxGuests: 6,
  amenities: ['Wi-Fi', 'Farm-to-table breakfast', 'Animal feeding experiences', 'Hiking trails', 'Fireplace', 'Private bathroom', 'Farm fresh produce', 'Mountain views', 'Organic garden', 'Horseback riding'],
  host: {
    id: 3,
    name: 'Emma',
    avatar: 'https://randomuser.me/api/portraits/women/63.jpg'
  },
  reviews: [{
    user: {
      name: 'Daniel',
      avatar: 'https://randomuser.me/api/portraits/men/29.jpg'
    },
    date: 'September 2023',
    comment: 'Our kids absolutely loved the farm experience! Collecting eggs and feeding the animals was the highlight of their trip. Emma is a wonderful host.'
  }, {
    user: {
      name: 'Olivia',
      avatar: 'https://randomuser.me/api/portraits/women/8.jpg'
    },
    date: 'August 2023',
    comment: 'The farm-to-table breakfast was incredible - you can taste the freshness of everything. The cabin was cozy and had everything we needed.'
  }, {
    user: {
      name: 'William',
      avatar: 'https://randomuser.me/api/portraits/men/86.jpg'
    },
    date: 'July 2023',
    comment: 'A perfect escape from city life. We learned so much about sustainable farming practices and enjoyed the peaceful mountain surroundings.'
  }]
}, {
  id: 4,
  title: 'Historic Southern Charm B&B with Garden',
  description: 'Experience authentic Southern hospitality in this meticulously restored 19th-century home. Wake up to a gourmet Southern breakfast served on the wraparound porch overlooking our heritage gardens. Each room features period antiques and modern luxuries.',
  location: 'Charleston, South Carolina',
  images: ['https://images.unsplash.com/photo-1566195992011-5f6b21e539aa?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80', 'https://images.unsplash.com/photo-1560185007-c5ca9d2c014d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80', 'https://images.unsplash.com/photo-1560185127-6ed189bf02f4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80', 'https://images.unsplash.com/photo-1600607686527-6fb886090705?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=687&q=80', 'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80'],
  pricePerNight: 225,
  rating: 4.9,
  reviewCount: 65,
  propertyType: 'bnb',
  bedrooms: 4,
  beds: 4,
  bathrooms: 4,
  maxGuests: 8,
  amenities: ['Wi-Fi', 'Gourmet Southern breakfast', 'Afternoon tea and cookies', 'Heritage gardens', 'Air conditioning', 'Private bathroom', 'Luxury linens', 'Evening port wine service', 'Wraparound porch', 'Walking distance to historic sites'],
  host: {
    id: 4,
    name: 'Benjamin',
    avatar: 'https://randomuser.me/api/portraits/men/22.jpg'
  },
  reviews: [{
    user: {
      name: 'Charlotte',
      avatar: 'https://randomuser.me/api/portraits/women/49.jpg'
    },
    date: 'September 2023',
    comment: "Benjamin's B&B is the epitome of Southern charm! The breakfast was divine and the location is perfect for exploring Charleston's historic district."
  }, {
    user: {
      name: 'Thomas',
      avatar: 'https://randomuser.me/api/portraits/men/18.jpg'
    },
    date: 'August 2023',
    comment: "Staying here was like stepping into a Southern Living magazine. The garden is spectacular and Benjamin's knowledge of local history added so much to our visit."
  }, {
    user: {
      name: 'Elizabeth',
      avatar: 'https://randomuser.me/api/portraits/women/92.jpg'
    },
    date: 'July 2023',
    comment: 'The attention to historic detail while maintaining modern comforts was impressive. The evening port wine in the parlor was a lovely touch!'
  }]
}, {
  id: 5,
  title: 'Coastal Organic Farmstay with Private Beach',
  description: 'Experience sustainable living at our coastal organic farm. Wake up to ocean views and enjoy farm-to-table meals featuring our own produce and seafood caught just offshore. Learn about organic farming practices or simply unwind on our private beach.',
  location: 'Outer Banks, North Carolina',
  images: ['https://images.unsplash.com/photo-1500382017468-9049fed747ef?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1332&q=80', 'https://images.unsplash.com/photo-1596178065887-1198b6148b2b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80', 'https://images.unsplash.com/photo-1598928506311-c55ded91a20c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80', 'https://images.unsplash.com/photo-1591825729269-caeb344f6df2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80', 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80'],
  pricePerNight: 275,
  rating: 4.8,
  reviewCount: 93,
  propertyType: 'farmstay',
  bedrooms: 3,
  beds: 5,
  bathrooms: 2,
  maxGuests: 8,
  amenities: ['Wi-Fi', 'Farm-to-table meals', 'Private beach access', 'Organic garden tours', 'Fishing excursions', 'Outdoor shower', 'BBQ facilities', 'Hammocks', 'Kayaks and paddleboards', 'Beachfront bonfire pit'],
  host: {
    id: 5,
    name: 'Rachel',
    avatar: 'https://randomuser.me/api/portraits/women/39.jpg'
  },
  reviews: [{
    user: {
      name: 'Andrew',
      avatar: 'https://randomuser.me/api/portraits/men/77.jpg'
    },
    date: 'September 2023',
    comment: "The perfect blend of farm life and beach vacation! Rachel's organic meals were incredible, and having private beach access was such a luxury."
  }, {
    user: {
      name: 'Natalie',
      avatar: 'https://randomuser.me/api/portraits/women/64.jpg'
    },
    date: 'August 2023',
    comment: 'We learned so much about sustainable farming while enjoying the beautiful coastal setting. Our kids loved helping with the chickens and collecting vegetables.'
  }, {
    user: {
      name: 'Christopher',
      avatar: 'https://randomuser.me/api/portraits/men/42.jpg'
    },
    date: 'July 2023',
    comment: 'The seafood dinner with ingredients we helped catch was a highlight of our trip. Rachel is passionate about sustainable living and it shows in every detail.'
  }]
}, {
  id: 6,
  title: 'Art Deco B&B with Rooftop Terrace',
  description: 'Stay in this stunning Art Deco B&B in the vibrant heart of the city. Our rooftop terrace offers panoramic skyline views - perfect for enjoying our signature breakfast mimosas. Each room features custom artwork and premium bedding for a luxurious stay.',
  location: 'Miami, Florida',
  images: ['https://images.unsplash.com/photo-1618773928121-c32242e63f39?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80', 'https://images.unsplash.com/photo-1560185008-b033106af5c3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80', 'https://images.unsplash.com/photo-1560185009-5bf9f2849488?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80', 'https://images.unsplash.com/photo-1560184897-67f4a3f9a7fa?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80', 'https://images.unsplash.com/photo-1560185127-59e4021beae9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80'],
  pricePerNight: 320,
  rating: 4.9,
  reviewCount: 76,
  propertyType: 'bnb',
  bedrooms: 5,
  beds: 6,
  bathrooms: 5,
  maxGuests: 10,
  amenities: ['Wi-Fi', 'Gourmet breakfast', 'Rooftop terrace', 'Cocktail hour', 'Air conditioning', 'Private bathroom', 'Luxury linens', 'Art Deco furnishings', 'Walking distance to beach', 'In-room spa services'],
  host: {
    id: 6,
    name: 'Alexander',
    avatar: 'https://randomuser.me/api/portraits/men/4.jpg'
  },
  reviews: [{
    user: {
      name: 'Victoria',
      avatar: 'https://randomuser.me/api/portraits/women/24.jpg'
    },
    date: 'September 2023',
    comment: "The Art Deco details are spectacular! Alexander's breakfast on the rooftop terrace was the perfect way to start each day in Miami."
  }, {
    user: {
      name: 'Matthew',
      avatar: 'https://randomuser.me/api/portraits/men/62.jpg'
    },
    date: 'August 2023',
    comment: "This B&B captures the essence of Miami's Art Deco style. The evening cocktail hour was a great way to meet other guests and get local tips."
  }, {
    user: {
      name: 'Jennifer',
      avatar: 'https://randomuser.me/api/portraits/women/19.jpg'
    },
    date: 'July 2023',
    comment: "The attention to detail in the decor is amazing, and the location couldn't be better. Alexander makes everyone feel like a VIP."
  }]
}, {
  id: 7,
  title: 'Vineyard Farmstay with Wine Tasting',
  description: 'Immerse yourself in vineyard life at our working winery and farm. Stay in our rustic-chic cottage surrounded by grapevines, participate in seasonal harvesting, and enjoy private wine tastings of our estate-produced wines paired with farm-to-table meals.',
  location: 'Willamette Valley, Oregon',
  images: ['https://images.unsplash.com/photo-1566750687878-8a10f14fb68f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1172&q=80', 'https://images.unsplash.com/photo-1488462237308-ecaa28b729d7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1114&q=80', 'https://images.unsplash.com/photo-1542718610-a1d656d1884c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80', 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=958&q=80', 'https://images.unsplash.com/photo-1464288550599-43d5a73451b8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1172&q=80'],
  pricePerNight: 295,
  rating: 4.9,
  reviewCount: 58,
  propertyType: 'farmstay',
  bedrooms: 2,
  beds: 2,
  bathrooms: 1,
  maxGuests: 4,
  amenities: ['Wi-Fi', 'Farm-to-table breakfast', 'Private wine tastings', 'Vineyard tours', 'Winemaking experiences', 'Fireplace', 'Private patio', 'Bicycle rentals', 'Valley views', 'Complimentary bottle of estate wine'],
  host: {
    id: 7,
    name: 'Olivia',
    avatar: 'https://randomuser.me/api/portraits/women/8.jpg'
  },
  reviews: [{
    user: {
      name: 'Samuel',
      avatar: 'https://randomuser.me/api/portraits/men/15.jpg'
    },
    date: 'September 2023',
    comment: "A wine lover's dream! Learning about viticulture firsthand while staying among the vines was an unforgettable experience. The private tastings were exceptional."
  }, {
    user: {
      name: 'Grace',
      avatar: 'https://randomuser.me/api/portraits/women/37.jpg'
    },
    date: 'August 2023',
    comment: "Olivia's knowledge of winemaking is impressive, and she's a wonderful host. The cottage is perfectly situated with gorgeous views of the vineyard and valley."
  }, {
    user: {
      name: 'Ryan',
      avatar: 'https://randomuser.me/api/portraits/men/57.jpg'
    },
    date: 'July 2023',
    comment: 'We helped with the grape harvest during our stay, which was both educational and fun! The farm-to-table dinner paired with their estate wines was divine.'
  }]
}, {
  id: 8,
  title: 'Music City B&B with Songwriter Sessions',
  description: "Experience Nashville's musical heritage at this unique B&B run by professional musicians. Enjoy gourmet Southern breakfasts, evening songwriter sessions in our parlor, and comfortable rooms named after music legends. Walking distance to Music Row.",
  location: 'Nashville, Tennessee',
  images: ['https://images.unsplash.com/photo-1566073771259-6a8506099945?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80', 'https://images.unsplash.com/photo-1505873242700-f289a29e1e0f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1176&q=80', 'https://images.unsplash.com/photo-1524758631624-e2822e304c36?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80', 'https://images.unsplash.com/photo-1493809842364-78817add7ffb?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80', 'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1080&q=80'],
  pricePerNight: 235,
  rating: 4.8,
  reviewCount: 82,
  propertyType: 'bnb',
  bedrooms: 4,
  beds: 5,
  bathrooms: 3,
  maxGuests: 8,
  amenities: ['Wi-Fi', 'Gourmet Southern breakfast', 'Evening songwriter sessions', 'Musical instruments available', 'Air conditioning', 'Private bathroom', 'Record player and vinyl collection', 'Music-themed decor', 'Front porch with rocking chairs', 'Walking distance to Music Row'],
  host: {
    id: 8,
    name: 'Noah',
    avatar: 'https://randomuser.me/api/portraits/men/32.jpg'
  },
  reviews: [{
    user: {
      name: 'Ava',
      avatar: 'https://randomuser.me/api/portraits/women/12.jpg'
    },
    date: 'September 2023',
    comment: "Noah's B&B captures the essence of Nashville's music scene! The songwriter session in the parlor was a highlight - we saw an up-and-coming artist who was amazing."
  }, {
    user: {
      name: 'Ethan',
      avatar: 'https://randomuser.me/api/portraits/men/26.jpg'
    },
    date: 'August 2023',
    comment: "As a music lover, this was the perfect place to stay in Nashville. Noah's industry knowledge and connections gave us insider access to the best venues."
  }, {
    user: {
      name: 'Madison',
      avatar: 'https://randomuser.me/api/portraits/women/95.jpg'
    },
    date: 'July 2023',
    comment: 'The musical heritage of the city comes alive in this B&B. The Johnny Cash room was fantastic, and breakfast was delicious every morning!'
  }]
}];
// Featured properties (subset of all properties)
export const featuredProperties = allProperties.slice(0, 4);
// Popular destinations
export const popularDestinations = [{
  id: 1,
  name: 'Malibu',
  image: 'https://images.unsplash.com/photo-1523906834658-6e24ef2386f9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1083&q=80',
  propertyCount: 24
}, {
  id: 2,
  name: 'New York',
  image: 'https://images.unsplash.com/photo-1496442226666-8d4d0e62e6e9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
  propertyCount: 115
}, {
  id: 3,
  name: 'Aspen',
  image: 'https://images.unsplash.com/photo-1542296332-2e4473faf563?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
  propertyCount: 32
}, {
  id: 4,
  name: 'Miami',
  image: 'https://images.unsplash.com/photo-1589083130544-0d6a2926e519?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
  propertyCount: 56
}, {
  id: 5,
  name: 'Portland',
  image: 'https://images.unsplash.com/photo-1572214384758-3cc0d64fe541?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
  propertyCount: 28
}, {
  id: 6,
  name: 'Nashville',
  image: 'https://images.unsplash.com/photo-1545419913-775e3e82c7db?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
  propertyCount: 41
}, {
  id: 7,
  name: 'Charleston',
  image: 'https://images.unsplash.com/photo-1578774341511-a31a1b5b1f7c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
  propertyCount: 19
}, {
  id: 8,
  name: 'Outer Banks',
  image: 'https://images.unsplash.com/photo-1604542031658-5799ca5d7936?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
  propertyCount: 27
}];
// Mock user bookings
export const mockUserBookings = [{
  id: 1,
  property: allProperties[0],
  checkIn: '2023-10-15',
  checkOut: '2023-10-20',
  guests: 4,
  totalPrice: 3250,
  status: 'confirmed'
}, {
  id: 2,
  property: allProperties[2],
  checkIn: '2023-11-05',
  checkOut: '2023-11-10',
  guests: 2,
  totalPrice: 975,
  status: 'pending'
}, {
  id: 3,
  property: allProperties[5],
  checkIn: '2023-07-10',
  checkOut: '2023-07-15',
  guests: 3,
  totalPrice: 2250,
  status: 'completed'
}, {
  id: 4,
  property: allProperties[3],
  checkIn: '2023-08-22',
  checkOut: '2023-08-26',
  guests: 5,
  totalPrice: 900,
  status: 'cancelled'
}];
// Mock user favorites
export const mockUserFavorites = [allProperties[1], allProperties[4], allProperties[6]];